import { useFormContext } from 'react-hook-form';
import { isConditionMet } from 'features/dynamicForm/utils/conditionHelper';

export function useIsShown(field) {
    const { getValues } = useFormContext();

    return !field.showConditions || field.showConditions?.some((condition) => isConditionMet(getValues, condition));
}
